export function objectEquals (x, y) {
  if (x === null || x === undefined || y === null || y === undefined) { return x === y }
    // after this just checking type of one would be enough
  if (x.constructor !== y.constructor) { return false }
    // if they are functions, they should exactly refer to same one (because of closures)
  if (x instanceof Function) { return x === y }
    // if they are regexps, they should exactly refer to same one (it is hard to better equality check on current ES)
  if (x instanceof RegExp) { return x === y }
  if (x === y || x.valueOf() === y.valueOf()) { return true }
  if (Array.isArray(x) && x.length !== y.length) { return false }

    // if they are dates, they must had equal valueOf
  if (x instanceof Date) { return false }

    // if they are strictly equal, they both need to be object at least
  if (!(x instanceof Object)) { return false }
  if (!(y instanceof Object)) { return false }

    // recursive object equality check
  let p = Object.keys(x)
  return Object.keys(y).every(function (i) { return p.indexOf(i) !== -1 }) &&
        p.every(function (i) { return objectEquals(x[i], y[i]) })
}

export function isEmpty (obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object
}

export function dataURItoBlob (dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  let byteString
  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1])
  } else {
    byteString = unescape(dataURI.split(',')[1])
  }

  // separate out the mime component
  let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length)
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  return new Blob([ia], {type: mimeString})
}

export function checkUserZoom () {
  let zoomLevel
  let screenCssPixelRatio = (window.outerWidth - 8) / window.innerWidth
  if (screenCssPixelRatio >= 0.46 && screenCssPixelRatio <= 0.54) {
    zoomLevel = -4
  } else if (screenCssPixelRatio <= 0.64) {
    zoomLevel = -3
  } else if (screenCssPixelRatio <= 0.76) {
    zoomLevel = -2
  } else if (screenCssPixelRatio <= 0.92) {
    zoomLevel = -1
  } else if (screenCssPixelRatio <= 1.08) {
    zoomLevel = 0
  } else if (screenCssPixelRatio <= 1.32) {
    zoomLevel = 1
  } else if (screenCssPixelRatio <= 1.58) {
    zoomLevel = 2
  } else if (screenCssPixelRatio <= 1.90) {
    zoomLevel = 3
  } else if (screenCssPixelRatio <= 2.28) {
    zoomLevel = 4
  } else if (screenCssPixelRatio <= 2.70) {
    zoomLevel = 5
  } else {
    zoomLevel = 'unknown'
  }
  return zoomLevel === 0
}

export function validateEmail (email) {
    // eslint-disable-next-line no-useless-escape
  let re = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/
  return re.test(email)
}

export function validateParticipantEmail (user) {
  if (user.fromNetwork !== 'TWITTER') {
      // eslint-disable-next-line no-useless-escape
    let re = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/
    return re.test(user.email)
  } else {
    return true
  }
}

export function validateMacAddress (address) {
  let re = /^([0-9A-F]{2}[:-]){5}([0-9A-F]{2})$/
  return re.test(address)
}

export function validateUri (uri) {
  let pattern = new RegExp('^([,;&a-z\u0080-\u00ff\\d%_.~+=-]*)?$', 'i')
  let valid = pattern.test(uri)
  return valid
}

export function isStrongPassword (password) {
  // eslint-disable-next-line no-useless-escape
  let regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\?\+\.-/!$]).{8,}/
  let validPassword = regExp.test(password)
  return validPassword
}

export function isAnEditableApp (app) {
  if (app.status) {
    return app.status === 'CONSTRUCTION'
  } else {
    return false
  }
}

export function isOwnerApp (login, app) {
  let isOwner = false
  app.usersFO.forEach((appUser, index) => {
    if (appUser.isOwner && appUser.userFO.email === login) {
      isOwner = true
    }
  })
  return isOwner
}

export function isUserApp (login, app) {
  let isUserApp = false
  app.usersFO.forEach((appUser, index) => {
    if (appUser.userFO.email === login) {
      isUserApp = true
    }
  })
  return isUserApp
}
